export default __webpack_public_path__ + "static/media/manuable-inabit.163d4716.svg";